import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Navigation from "src/components/Navigation/Navigation";
import { INavigationContainer } from "src/ScrollyInterface";
import * as actions from "src/store/actions/index";
import { INavigationClickedAction, IStateApp } from "src/store/StoreInterface";

const navigationContainer = (props: INavigationContainer) => {
  const { content, navImages, navType, onNavigationClicked } = props;
  return (
    <Navigation
      contentId={content.id}
      navImages={navImages}
      navType={navType}
      onNavigationClicked={onNavigationClicked}
      color={content.color || "#fff"}
    />
  );
};

const mapStateToProps = (state: IStateApp) => {
  return {
    content: state.data.content
  };
};

const mapDispatchToProps = (dispatch: Dispatch<INavigationClickedAction>) => {
  return {
    onNavigationClicked: (id: number) => dispatch(actions.navigationClicked(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(navigationContainer);



// WEBPACK FOOTER //
// ./src/containers/NavigationContainer.tsx